module.exports = {"title":"选择注册模式＆获取注册资讯","plateFormBaseDescription":"利用此模式注册节点后，可将节点调配给任意群组，并且使用防御模式。","groupTokenBaseDescription":"此模式可以注册专属于这个群组的节点。","nextStep":"下一步","preStep":"上一步","gotIt":"了解","step1":"步骤一","step2":"步骤二","selected":"已选择","select":"选择","inUsed":"使用中","noVailableText":"没有可使用的令牌","revoke":"撤销","revokeRemindText":"此动作将会让对应到此令牌的节点失效，确定要撤销此令牌吗？"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/nodeRegisteration.json
// module id = xJZH
// module chunks = 3